module.exports = __webpack_public_path__ + "static/back_event_06-9ef2bd79f8d498fe59eccc43d96f5d83.jpg";